/**
 * /admin/entity-graph — the firm's entity graph (Map) + anomalies inbox (route shell).
 * Screen impl in `./entity-graph-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/entity-graph')({
  component: lazyRouteComponent(() => import('./entity-graph-screen'), 'AdminEntityGraph'),
});
